"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SINGLE_ORDER = void 0;
var SINGLE_ORDER = {
  ICON__EDIT_PRODUCT: 'singleOrderView-icon-editProduct',
  ICON__EDIT_DELIVERY_FEE: 'singleOrderView-icon-editDeliveryFee',
  ICON__EDIT_DELIVERY_DATE: 'singleOrderView-icon-editDeliveryDate',
  BUTTON__ACCEPT: 'singleOrderView-button-acceptOrder',
  BUTTON__ADD_DELIVERY_FEE: 'singleOrderView-button-addDeliveryFee',
  BUTTON__ADD_PRODUCTS: 'singleOrderView-button-addProduct',
  BUTTON__EDIT_SAVE: 'singleOrderView-button-saveChanges',
  BUTTON__REORDER: 'singleOrderView-button-reorder',
  BUTTON__DISPUTE: 'singleOrderView-button-dispute',
  BUTTON__EDIT_DISCARD: 'singleOrderView-button-discard',
  BUTTON__MANAGE_ORDER: 'singleOrderView-button-manageOrder',
  BUTTON__VIEW_ORDER: 'singleOrderView-button-viewOrder',
  TEXT__WARNING_INVENTORY: 'singleOrderView-div-inventoryWarning',
  TEXT__PRODUCT_AVAILABLE: 'singleOrderView-span-productInventoryAvailable',
  TEXT__PRODUCT_SKU: 'singleOrder-value-productSKU',
  TEXT__PRODUCT_QTY: 'singleOrder-value-productQuantity',
  TEXT__ORDER_NUMBER: 'singleOrder-value-orderNumber',
  TEXT__PRODUCT_NAME: 'singleOrder-value-productName',
  TEXT__TOTAL_AMOUNT: 'singleOrder-value-totalAmount',
  TEXT__DELIVERY_FEE: 'singleOrder-value-deliveryFee',
  TEXT__DELIVERY_FEE_TITLE: 'singleOrder-span-deliveryFeeTitle',
  TEXT__DELIVERY_FEE_DESCRIPTION: 'singleOrder-span-deliveryFeeDescription',
  TEXT__CREDIT_NOTE: 'singleOrder-span-creditNote',
  TEXT__CREDIT_NOTE_TITLE: 'singleOrder-span-creditNoteTitle',
  TEXT__CREDIT_NOTE_DESCRIPTION: 'singleOrder-span-creditNoteDescription',
  TEXT__DELIVERY_DATE: 'singleOrder-value-deliveryDate',
  TEXT__PRODUCT_PRICE: 'singleOrder-value-productPrice',
  TEXT__REQUESTED_DATE: 'singleOrder-value-requestedDate',
  TEXT__DISPUTE_ALERT: 'singleOrder-text-disputeAlert',
  TEXT__NOT_MATCHING_ALERT: 'singleOrder-text-notMatchingAlert',
  ROW__INCLUDED_PRODUCT: 'singleOrder-tr-includedProduct',
  ROW__EXCLUDED_PRODUCT: 'singleOrder-tr-excludedProduct',
  ROW__HISTORY_LOG: 'singleOrder-li-historyLog'
};
exports.SINGLE_ORDER = SINGLE_ORDER;